'use client';

import React from 'react';
import Footer from '../components/Footer';
import Bottom from './Bottom';
import Header from '../components/Header';
import Introduce from './Introduce';
import Solutions from './Solutions';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import { ProductContextProvider } from '../products/productContext';

export default function SolutionsPage() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
      <div className="flex flex-col justify-center w-full bg-base-white">
        <Header />
        <div className="flex flex-col items-center justify-center z-10 mt-[68px] w-full mx-auto">
          <Introduce />
          <ProductContextProvider>
            <div className="flex flex-col items-center justify-center w-full bg-gray-50 pt-10xl pb-[120px]">
              <Solutions />
            </div>
          </ProductContextProvider>
        </div>
        <Bottom />
        <Footer />
      </div>
    );
}
